import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, makeStyles } from '@material-ui/core';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { HERO, HERO_MD, HERO_XS } from '../Assets';
import { HomeComponentContainer } from './styled';
import { MediaQuery } from '../HomePresenter';
import { colorSet } from '@components/Provider';

const HomeMain: React.FC = () => {
  const { homeContainer, container, textBox } = useStyles();
  const { md, sm } = useContext(MediaQuery);
  const history = useHistory();

  return (
    <HomeComponentContainer
      className={homeContainer}
      padding={sm ? '97px 16px' : md ? '170px 0px' : '215px 0px'}
    >
      <Box className={container}>
        <Box className={textBox}>
          <CustomizedTypography variant={sm ? 'h3' : 'h1'} fontWeight="700">
            최고의 제조 파트너를 연결, <br />
            제조를 쉽고 편하게
          </CustomizedTypography>
          <CustomizedTypography
            className="mainDescription"
            color="textSecondary"
          >
            도면과 함께 간단한 견적요청서를 작성하면 <br />
            전문업체가 채팅으로 직접 상담해 드려요.
          </CustomizedTypography>
        </Box>

        <CustomizedButton
          data-testid="big-blue-button"
          variant="contained"
          size="large"
          color="primary"
          onClick={() => {
            history.push('/request');
          }}
        >
          <CustomizedTypography
            variant={sm ? 'body1' : 'h4'}
            fontWeight="500"
            color="inherit"
          >
            <i className="request-gtm-startMakeRFQ-btn">견적 요청하기</i>
          </CustomizedTypography>
        </CustomizedButton>
      </Box>
    </HomeComponentContainer>
  );
};

export default HomeMain;

const useStyles = makeStyles((theme) => ({
  homeContainer: {
    display: 'flex',
    position: 'relative',
    minHeight: 800,
    overflow: 'hidden',
    backgroundImage: `linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 50%), url(${HERO})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.down('md')]: {
      height: 1131,
      backgroundImage: `linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%), url(${HERO_MD})`,
      justifyContent: 'flex-start !important'
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 0,
      maxHeight: 667,
      backgroundImage: `linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%), url(${HERO_XS})`
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '92px',
    paddingTop: 32,
    '& button': {
      width: 198,
      height: 64,
      borderRadius: 12
    },
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      paddingTop: '0',
      gap: '65px'
    },
    [theme.breakpoints.down('sm')]: {
      gap: '32px',
      '& button': {
        width: 154,
        height: 48
      }
    }
  },
  textBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    '& h1': {
      fontSize: '54px',
      color: colorSet.gray000
    },
    '& h3': {
      color: colorSet.gray000,
      textAlign: 'center'
    },
    '& .mainDescription': {
      fontSize: '22px',
      color: colorSet.gray500
    },
    [theme.breakpoints.down('md')]: {
      '& h1': {
        fontSize: '46px',
        textAlign: 'center'
      },
      '& .mainDescription': {
        fontSize: '20px',
        textAlign: 'center'
      }
    },
    [theme.breakpoints.down('sm')]: {
      gap: '20px',
      '& .mainDescription': {
        fontSize: '16px',
        color: colorSet.gray500
      }
    }
  }
}));
